<template>
  <div class="detail_page">
    <el-tabs v-model="pageIndex" class="tabs-container">
      <el-tab-pane
        :label="$t('zlfk.jbxx')"
        name="problemDetailTab"
      ></el-tab-pane>
      <el-tab-pane
        v-if="problemData.regionalManageReview === 1"
        :label="$t('zlfk.yjcs')"
        name="emergencyMeasureTab"
      ></el-tab-pane>
      <el-tab-pane :label="$t('zlfk.cljl')" name="dealInfoTab"></el-tab-pane>
    </el-tabs>
    <div class="contentInfo">
      <div v-show="pageIndex === 'problemDetailTab'">
        <!-- <el-form :inline="true" :model="problemData"> -->
        <!-- 基本信息 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/basicRed.png" alt="dark" />
              {{ $t("zlfk.jbxx") }}
            </div>
          </div>
          <div class="form-container">
            <el-descriptions class="desc-container" :column="3" border>
              <!-- 序号 -->
              <el-descriptions-item :label="$t('zlfk.wtbh')">
                {{ problemData.questionNum }}
              </el-descriptions-item>
              <!-- 故障发生日期 -->
              <el-descriptions-item :label="$t('zlfk.gzfsrq')">
                {{ problemData.happenDate }}
              </el-descriptions-item>
              <!-- 故障发生地点 -->
              <el-descriptions-item :label="$t('zlfk.gzfsdd')">
                {{ problemData.happenPlace }}
              </el-descriptions-item>
              <!-- 生产日期 -->
              <el-descriptions-item :label="$t('seek.produceDate')">
                {{ problemData.productionDate }}
              </el-descriptions-item>
              <!-- 报修日期 -->
              <el-descriptions-item :label="$t('seek.warrantyDate')">
                {{ problemData.repairDate }}
              </el-descriptions-item>
              <!-- 严重程度 -->
              <el-descriptions-item
                :label="$t('restockInfo.yzcd')"
                label-class-name="custom-label"
              >
                {{ problemData.severityLevel }}
              </el-descriptions-item>
              <!-- 是否重点问题 -->
              <el-descriptions-item
                :label="$t('zlfk.sfzdwt')"
                label-class-name="custom-label"
              >
                {{
                  problemData.importantType == 1
                    ? $t("seek.yes")
                    : $t("seek.no")
                }}
              </el-descriptions-item>
              <!-- 重点问题描述 -->
              <el-descriptions-item
                :label="$t('zlfk.zdwtms')"
                label-class-name="custom-label"
                v-if="problemData.importantType === 1"
              >
                {{ problemData.importantDescribe }}
              </el-descriptions-item>
              <!-- 是否有维修措施 -->
              <el-descriptions-item
                :label="$t('zlfk.sfywxcs')"
                label-class-name="custom-label"
              >
                {{
                  problemData.serviceMeasure == 1
                    ? $t("seek.yes")
                    : $t("seek.no")
                }}
              </el-descriptions-item>
              <!-- 市场维修措施 -->
              <el-descriptions-item
                v-if="problemData.serviceMeasure == 1"
                :label="$t('restockInfo.cswxcs')"
                label-class-name="custom-label"
              >
                {{ problemData.marketService }}
              </el-descriptions-item>
              <!-- 零部件类别 -->
              <el-descriptions-item
                :label="$t('zlfk.lztype')"
                label-class-name="custom-label"
              >
                <div
                  v-for="(item, index) in componentCategoryList"
                  :key="index"
                >
                  <div v-if="item.code == problemData.componentCategory">
                    {{ item[componentCategoryName.get($i18n.locale)] }}
                  </div>
                </div>
              </el-descriptions-item>
              <!-- 零部件批次信息 -->
              <el-descriptions-item :label="$t('zlfk.lzpcinfo')">
                {{ problemData.componentBatchs }}
              </el-descriptions-item>
              <!-- 发动机型号 -->
              <el-descriptions-item
                :label="$t('seek.onlyEngine')"
                v-if="
                  problemData.componentBatchs == '1' ||
                  problemData.componentBatchs == '2'
                "
              >
                {{ problemData.engineModel }}
              </el-descriptions-item>
              <!-- 发动机号 -->
              <el-descriptions-item
                :label="$t('seek.engineNUmber')"
                v-if="
                  problemData.componentBatchs == '1' ||
                  problemData.componentBatchs == '2'
                "
              >
                {{ problemData.engineNumber }}
              </el-descriptions-item>
              <!-- 动力电池号 -->
              <el-descriptions-item
                :label="$t('restockInfo.dldch')"
                v-if="problemData.componentBatchs == '8'"
              >
                {{ problemData.batteryNumber }}
              </el-descriptions-item>
              <!-- 电机号 -->
              <el-descriptions-item
                :label="$t('climant.djNumer')"
                v-if="problemData.componentBatchs == '8'"
              >
                {{ problemData.motorNumber }}
              </el-descriptions-item>
              <!-- 订单号 -->
              <el-descriptions-item :label="$t('cart.orderNumber')">
                {{ problemData.orderNum }}
              </el-descriptions-item>
              <!-- 订单数量 -->
              <el-descriptions-item :label="$t('zlfk.orderNum')">
                {{ problemData.carTotal }}
              </el-descriptions-item>
              <!-- 故障数量 -->
              <el-descriptions-item
                :label="$t('zlfk.gznum')"
                label-class-name="custom-label"
              >
                {{ problemData.faultNumber }}
              </el-descriptions-item>
              <!-- 疑似/祸首件代码 -->
              <el-descriptions-item :label="$t('seek.culpritCode')">
                {{ problemData.suspectPartNumber }}
              </el-descriptions-item>
              <!-- 疑似/祸首件名称 -->
              <el-descriptions-item :label="$t('seek.culpritName')">
                {{ problemData.suspectPartName }}
              </el-descriptions-item>
              <!-- 供应商代码/名称 -->
              <!-- <el-descriptions-item :label="$t('restockInfo.supplierInfo')">
                {{ problemData.supplierInfo }}
              </el-descriptions-item> -->
            </el-descriptions>

            <!-- 翻译 -->
            <!--<div> <el-form-item v-if="problemData.importantType === 1">
              <translate-btn
                style="padding-left: 10px"
                :content="problemData.importantDescribe"
                field="importantDescribeVal"
                @getTranslateVal="
                  (field, value) => {
                    this.$set(problemData, field, value);
                  }
                "
              />
            </el-form-item> -->
            <!-- 重点问题描述翻译 -->
            <!-- <el-form-item v-if="problemData.importantDescribeVal">
              <el-input
                disabled
                v-model="problemData.importantDescribeVal"
              ></el-input>
            </el-form-item>  </div>-->
          </div>
        </div>

        <!-- 问题描述 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/wtmsred.png" alt="" />
              {{ $t("zlfk.wtms") }}
            </div>
          </div>
          <div class="form-container">
            <el-descriptions class="desc-container" :column="3" border>
              <!-- 故障描述 -->
              <el-descriptions-item :label="$t('restockInfo.gzxxms')" :span="6">
                {{ problemData.questionContent }}
              </el-descriptions-item>
              <!-- 重复性 -->
              <el-descriptions-item :label="$t('restockInfo.cfx')">
                {{
                  problemData.repeatability == 0
                    ? $t("restockInfo.exist")
                    : $t("restockInfo.occasional")
                }}
              </el-descriptions-item>
              <!-- 有无超载 -->
              <el-descriptions-item :label="$t('seek.overload')">
                {{
                  problemData.overload == 0
                    ? $t("restockInfo.have")
                    : $t("restockInfo.not")
                }}
              </el-descriptions-item>
              <!-- 行驶工况 -->
              <el-descriptions-item :label="$t('seek.drivingConditions')">
                {{ problemData.drivingCondition }}
              </el-descriptions-item>
              <!-- 行驶路况 -->
              <el-descriptions-item :label="$t('seek.road')">
                {{ problemData.roadCondition }}
              </el-descriptions-item>
              <!-- 天气情况 -->
              <el-descriptions-item :label="$t('seek.weather')">
                {{ problemData.weatherCondition }}
              </el-descriptions-item>
              <!-- 加装情况 -->
              <el-descriptions-item :label="$t('restockInfo.jzqk')">
                {{ problemData.modificationStatus }}
              </el-descriptions-item>
              <!-- 附件 -->
              <!-- <el-descriptions-item :label="$t('zlfk.fj')" :span="6">
                  <file-upload-list ref="fileUploadList" :fileList="problemData.faultCommonFiles"></file-upload-list>
              </el-descriptions-item> -->
            </el-descriptions>
          </div>
        </div>

        <!-- 图片和视频 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/imgRed.png" alt="" />
              {{ $t("restockInfo.imgVideo") }}
            </div>
          </div>
          <div class="form-container">
            <el-descriptions class="desc-container" :column="1" border>
              <!-- 故障视频/图片 -->
              <el-descriptions-item :label="$t('restockInfo.gzTitle')">
                <file-upload-list
                  ref="fileUploadList"
                  :fileList="problemData.faultVideoFiles"
                ></file-upload-list>
              </el-descriptions-item>
              <!-- 故障代码 -->
              <el-descriptions-item
                :label="$t('restockInfo.gzcode')"
                v-bind="descContentClass"
              >
                <div :class="getRemarkClass(problemData.faultCodeRemark)">
                  {{ problemData.faultCodeRemark }}
                </div>
                <file-upload-list
                  v-if="problemData.faultCodeFiles.length > 0"
                  ref="fileUploadList"
                  :fileList="problemData.faultCodeFiles"
                ></file-upload-list>
              </el-descriptions-item>
              <!-- 其他说明 -->
              <el-descriptions-item
                :label="$t('restockInfo.otherInfo')"
                v-bind="descContentClass"
              >
                <div :class="getRemarkClass(problemData.otherRemark)">
                  {{ problemData.otherRemark }}
                </div>
                <file-upload-list
                  v-if="problemData.otherFiles.length > 0"
                  ref="fileUploadList"
                  :fileList="problemData.otherFiles"
                ></file-upload-list>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <!-- 发动机变速器保养记录 -->
        <div
          v-if="
            problemData.componentCategory == '1' ||
            problemData.componentCategory == '2'
          "
        >
          <div class="hearder-title">
            <div
              class="flex_between"
              v-if="problemData.componentCategory == '1'"
            >
              <img src="@/assets/image/engineRecordsRed.png" alt="" />
              {{ $t("home.engineRecord") }}
            </div>
            <div class="flex_between" v-else>
              <img src="@/assets/image/gearboxRed.png" alt="" />
              {{ $t("home.transmissionRecord") }}
            </div>
          </div>
          <div>
            <el-table
              ref="tableRef"
              stripe
              border
              highlight-current-row
              :data="
                problemData.componentCategory == '1'
                  ? problemData.maintenanceRecordInfo.engineRecordList
                  : problemData.maintenanceRecordInfo.transmissionRecordList
              "
            >
              <!-- 序号 -->
              <el-table-column
                :label="$t('cart.xh')"
                width="60px"
                align="center"
                :render-header="$globalRenderHeader"
              >
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <!-- 时间 -->
              <el-table-column
                :label="$t('home.date')"
                width="180px"
                align="center"
                :render-header="$globalRenderHeader"
                property="time"
              >
              </el-table-column>
              <el-table-column
                :label="$t('zlfk.mileage')"
                width="120px"
                align="center"
                property="mileage"
                :render-header="$globalRenderHeader"
              >
              </el-table-column>
              <el-table-column
                :label="$t('zlfk.bycontent')"
                width="120px"
                align="center"
                property="content"
                :render-header="$globalRenderHeader"
              >
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('zlfk.fj')"
                min-width="300px"
                align="center"
                :render-header="$globalRenderHeader"
              >
                <template slot-scope="scope">
                  <file-upload-list
                    ref="fileUploadList"
                    :fileList="scope.row.photos"
                  ></file-upload-list>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 变速器保养记录 -->
        <!-- <div v-if="problemData.componentCategory == '2'">
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/gearboxRed.png" alt="" />
              {{ $t("home.transmissionRecord") }}
            </div>
          </div>
          <div>
            <el-table ref="tableRef" stripe border highlight-current-row
              :data="problemData.maintenanceRecordInfo.transmissionRecordList">

              <el-table-column :label="$t('cart.xh')" width="60px" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('home.date')" width="180px" align="center"
                :render-header="$globalRenderHeader" property="time">
              </el-table-column>
              <el-table-column :label="$t('zlfk.mileage')" width="120px" align="center" property="mileage"
                :render-header="$globalRenderHeader">
              </el-table-column>
              <el-table-column :label="$t('zlfk.bycontent')" width="120px" align="center" property="content"
                :render-header="$globalRenderHeader">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('zlfk.fj')" min-width="300px" align="center"
                :render-header="$globalRenderHeader">
                <template slot-scope="scope">
                  <file-upload-list ref="fileUploadList" :fileList="scope.row.photos"></file-upload-list>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div> -->
        <!-- 临时措施 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/interimMeasure.png" alt="" />
              {{ $t("zlfk.temporary") }}
            </div>
          </div>
          <div>
            <el-descriptions class="desc-container" :column="1" border>
              <!-- 临时措施 -->
              <el-descriptions-item :label="$t('zlfk.temporary')">
                {{ provisionalMeasures }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>
      <div v-show="pageIndex === 'emergencyMeasureTab'">
        <emergency-measure :problemData="problemData" />
      </div>
      <div v-show="pageIndex === 'dealInfoTab'">
        <audit-record :recordList="recordList"/>
      </div>
      <!-- 问题编辑修改组件 -->
      <after-problem-dialog ref="afterProblemDialog" @success="getDetail" />
      <!-- 审核组件 -->
      <audit-dialog ref="auditDialog" />
      <!-- 预览图片视频组件 -->
      <view-img-video ref="viewRef" :list="fileInfoList" />
    </div>
    <div class="footer-button">
      <el-button
        v-if="problemData.status === 0 || problemData.status === 3"
        class="primary-btn lang-but"
        type="primary"
        @click="handleEdit"
        >{{ $t("zlfk.bjwt") }}</el-button
      >
      <el-button
        v-if="problemData.status === 2"
        class="primary-btn lang-but"
        type="primary"
        @click="handleExamine('approval', true, 'accept')"
        >{{ $t("home.confirm") }}</el-button
      >
<!--      <el-button-->
<!--        v-if="problemData.status === 2"-->
<!--        class="danger-btn lang-but"-->
<!--        type="danger"-->
<!--        @click="handleExamine('approval', false, 'disagree')"-->
<!--        >{{ $t("message.bh") }}</el-button-->
<!--      >-->
      <el-button
        v-if="problemData.status === 3"
        plain
        class="primary-btn lang-but"
        type="primary"
        @click="handelCancel"
        >{{ $t("seek.cancel") }}</el-button
      >
      <!-- <el-button class="primary-btn" type="primary" @click="back">
        {{ $t("operate.backList") }}
      </el-button> -->
    </div>
  </div>
</template>
<script>
import { getStorage, setStorageNew } from "@/util/localStor";
import { preAfterSalesQuestionListApi, auditHistoryList } from "@/api/feedback";
import AuditRecord from "./auditRecord.vue";
import EmergencyMeasure from "./emergencyMeasure.vue";
import AfterProblemDialog from "./afterProblemDialog.vue";
import AuditDialog from "./auditDialog.vue";
import ViewImgVideo from "@/components/viewImgVideo.vue";
import TranslateBtn from "@/components/translateBtn.vue";
import faultData from "@/mixins/faultData";
export default {
  components: {
    AuditRecord,
    EmergencyMeasure,
    AfterProblemDialog,
    AuditDialog,
    ViewImgVideo,
    TranslateBtn,
  },
  mixins: [faultData],
  data() {
    return {
      qualityData: {}, // 反馈单数据
      problemData: {}, // 问题数据
      pageIndex: "problemDetailTab", // 详情 | 记录
      fileInfoList: [],
      provisionalMeasures: "",
      pageName: "zlfk.ckfkd",
      recordList: [],
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getInitializeInfo();
    }
  },
  async created() {
    this.getInitializeInfo();
  },
  computed: {
    // 图片视频内容className
    descContentClass() {
      return {
        contentClassName: "content-input",
      };
    },
  },
  methods: {
    getInitializeInfo() {
      // 反馈单数据
      this.qualityData = getStorage("qualityData");
      this.problemData = getStorage("problemData");
      this.problemData.faultCommonFiles = this.convertArrayData(
        this.problemData.faultCommonFiles
      );
      this.problemData.faultVideoFiles = this.convertArrayData(
        this.problemData.faultVideoFiles
      );
      this.problemData.faultCodeFiles = this.convertArrayData(
        this.problemData.faultCodeFiles
      );
      this.problemData.otherFiles = this.convertArrayData(
        this.problemData.otherFiles
      );
      this.getTypeList();
      this.sizeArea();
      this.getMeasureDetail();
      // this.getMetaData();
    },
    // 返回上一步
    // getMetaData() {
    //   if (sessionStorage.getItem("goBackPath")) {
    //     this.$route.meta.father = this.pageName;
    //     this.$route.meta.fatherPath = sessionStorage.getItem("goBackPath");
    //   }
    // },
    // back() {
    //   this.$router.go(-1);
    // },
    // 备注className
    getRemarkClass(item) {
      return item?.length ? "remarkInfo" : "";
    },
    // 获取临时措施
    async getMeasureDetail() {
      const res = await auditHistoryList({
        data: { questionId: this.problemData.questionId },
      });
      this.recordList = res.data;
      this.recordList.forEach((item) => {
        if (item.provisionalMeasures) {
          this.provisionalMeasures = item.provisionalMeasures;
        }
      });
    },
    // 详情 | 记录
    handleViewRecord(index) {
      this.pageIndex = index;
    },
    //  编辑问题
    handleEdit() {
      this.$refs.afterProblemDialog.init(
        this.$t("zlfk.bjwt"),
        this.problemData,
        "edit"
      );
    },
    // 审核问题
    handleExamine(field, value, dialogType) {
      var examineParams = {
        ...this.problemData,
        variables: {},
      };
      var title = "";
      var examineTip = `${this.$t("zlfk.wt")} ${examineParams.questionNum} `;
      examineParams.variables[field] = value;
      // 通过驳回
      if (field === "approval") {
        title = value ? "通过" : this.$t("message.bh");
        examineTip =
          examineTip + value
            ? this.$t("home.passed")
            : this.$t("climant.rejected");
        if (dialogType === "accept") {
          title = this.$t("zlfk.rk");
          examineTip = `${this.$t("zlfk.wt")} ${
            examineParams.questionNum
          } ${this.$t("zlfk.yrk")}`;
        }
      }
      this.$refs.auditDialog.init(title, examineTip, examineParams, dialogType);
    },
    // 取消
    handelCancel() {
      this.getDealerCancel();
    },
    // 获取问题详情
    async getDetail() {
      const res = await preAfterSalesQuestionListApi({
        data: {
          feedbackFormId: this.problemData.feedbackFormId,
          questionNum: this.problemData.questionNum,
        },
        page: {
          pageNum: 1,
          pageSize: 1,
        },
      });
      this.problemData = { ...res.data?.records[0] };
      setStorageNew("problemData", this.problemData);
    },
    // 内容高度
    heightSize() {
      setTimeout(() => {
        var allHeight = $(".detail_page").height();
        var tabHeight = $(".tabs-container").outerHeight(true);
        var footerHeight =
          $(".footer-button")?.length > 0
            ? $(".footer-button").outerHeight(true)
            : 0;
        const val = allHeight - tabHeight - footerHeight;
        $(".contentInfo").css("height", val);
      }, 100);
    },
    sizeArea() {
      var _this = this;
      _this.heightSize();
      window.addEventListener("resize", function () {
        _this.heightSize();
      });
    },
  },
};
</script>
